<template>

    <div class="flex-center position-ref full-height">
      <div class="content">
        <div class="title m-b-md" style="font-size: 48px;">
          <img src="../assets/common/logo.png" alt="Logo" class="logo" />
        </div>
        <br />
        <div class="title m-b-md" style="font-size: 48px;">Ηλεκτρονικό Σύστημα Διπλωματικών</div>
        <br />
        <div
          class="title m-b-md"
          style="font-size: 20px;"
        >Τμήμα Μηχανικών Πληροφορικής και Ηλεκτρονικών Συστημάτων</div>
        <br />
        <div>Διεθνές Πανεπιστήμιο Ελλάδος</div>
        <br />
        <a
          href="/files/Σύντομος Οδηγός ΔΕ_ΠΕ.pdf"
          target="_blank"
        >{{this.Translate("@_MANUAL")}}</a>
      </div>
    </div>

</template>

<script>
import Mixin from "@/helpers/mixin";

export default {
  name: "Home",
  mixins: [Mixin],
  computed: {}
};
</script>

<style scoped>
 html,
body {
  background-color: #fff;
  color: #636b6f;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-weight: 100;
  height: 70vh;
  margin: 0;
} 

.full-height {
  height: 70vh;
}

.flex-center {
  align-items: center;
  display: flex;
  justify-content: center;
}

.position-ref {
  position: relative;
}

.top-right {
  position: absolute;
  right: 10px;
  top: 10px;
}

.content {
  text-align: center;
}

.title {
  font-size: 84px;
}

.links > a {
  color: #636b6f;
  padding: 0 25px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1rem;
  text-decoration: none;
  text-transform: uppercase;
}

.m-b-md {
  margin-bottom: 30px;
}

@media (prefers-color-scheme: dark) {
  html {
    --hue: 201; /* Teithe it apps blue */
    --saturation: 0%;
    --text-color-normal: hsl(var(--hue), var(--saturation), 85%);
    --text-color-light: hsl(var(--hue), var(--saturation), 95%);

    --border-color: hsl(var(--hue), var(--saturation), 30%);
  }

  body {
    color: var(--text-color-normal) !important;
    background-color: hsl(var(--hue), var(--saturation), 18%);
  }

  a {
    color: #fff;
  }
}
</style>
